/**
 * Calcula edad en años cumplidos a partir de una fecha (ISO yyyy-mm-dd o con tiempo).
 */
export function calcularEdadAnios(fechaNacimiento) {
  if (!fechaNacimiento) return null;
  const d = fechaNacimiento instanceof Date ? fechaNacimiento : new Date(fechaNacimiento);
  if (Number.isNaN(d.getTime())) return null;
  const hoy = new Date();
  let edad = hoy.getFullYear() - d.getFullYear();
  const m = hoy.getMonth() - d.getMonth();
  if (m < 0 || (m === 0 && hoy.getDate() < d.getDate())) edad -= 1;
  return edad >= 0 ? edad : null;
}

/**
 * Obtiene la edad del estudiante desde el objeto usuario (JWT o perfil).
 */
export function obtenerEdadEstudiante(user) {
  if (!user) return null;
  const directa = user.Edad ?? user.edad;
  if (directa !== undefined && directa !== null && directa !== "") {
    const n = Number(directa);
    if (!Number.isNaN(n) && n >= 0) return n;
  }
  const fn =
    user.FechaNacimiento ??
    user.fechaNacimiento ??
    user.Fecha_Nacimiento ??
    user.birthDate;
  return calcularEdadAnios(fn);
}
